import enTitleTranslation from './en/index.json'
import jaTitleTranslation from './ja/index.json'

export const resources = {
  en: {
    translation: enTitleTranslation,
  },
  ja: {
    translation: jaTitleTranslation,
  },
} as const
